import { Button, ContactCardIcon, ContactGroupIcon, Flex, Input, ListIcon, MenuButton, SearchIcon, SettingsIcon, SplitButton, StarIcon } from "@fluentui/react-northstar";
import { useNavbar } from "./Navbar.logic";
import React, { memo } from "react";
import { primaryStyle } from "../../utils/primaryStyle";
import "./Navbar.scss";
import { IDisplayMode } from "../../interfaces/IDisplayMode";
import { InformationMenu, useAppConfigurationSelector, useConfigurationSelector, useModalSelector, Modal, ReviewDialog } from "front";
import { StarFilled } from "@fluentui/react-icons";

const Navbar = memo(() => {
  const { t, menus, currentDisplayMode, register, createNewContact, canAddContact, isPremium, openReviewDialog} = useNavbar();
  const { isOpen } = useModalSelector("isOpen");
  const { from } = useAppConfigurationSelector("from");
  const { data: config } = useConfigurationSelector("data");

  const renderIconByChoice = () => {
    if (currentDisplayMode == IDisplayMode.CARD) {
      return <ContactCardIcon />;
    } else if (currentDisplayMode == IDisplayMode.GROUP) {
      return <ContactGroupIcon />;
    }
    return <ListIcon></ListIcon>;
  };

  const renderReviewDialog = () => {
    if (isOpen != Modal.REVIEW) return;
    return <ReviewDialog from={from} teamsAppId={config?.manifestId} />;
  };

  return (
    <Flex style={{ padding: "1.25rem" }} className="navbar-container">
      <Flex className="navbar-left">
        <SplitButton
          className="split-btn"
          primary
          menu={menus.addNewMenu}
          button={{
            content: `${t("New")} ${t("Contact")}`,
            disabled: !canAddContact,
            "data-testid": "navbar-new-contact-btn",
          }}
          onMainButtonClick={createNewContact}
          data-testid="navbar-new-btn"
        />
        <MenuButton
          style={{ marginLeft: ".5rem" }}
          trigger={<Button primary styles={primaryStyle} icon={renderIconByChoice()} content={t(currentDisplayMode)} data-testid="navbar-display-mode-btn" />}
          menu={menus.displayModeMenu}
          on="click"
        />
      </Flex>
      <Flex fill className="navbar-right" gap="gap.smaller">
        <div className="navbar-inp-container" data-testid="navbar-search">
          <Input icon={<SearchIcon />} placeholder={t("SearchContact")} iconPosition="start" fluid inverted {...register("search")} />
        </div>
        {<Button
          data-testid="navbar-review-btn"
          icon={<StarIcon outline />}
          iconOnly
          onClick={openReviewDialog}
        />}
        <MenuButton trigger={<Button icon={<SettingsIcon outline />} iconOnly data-testid="navbar-more-options-btn" />} menu={menus.moreMenu} on="click" />
        <InformationMenu />
      </Flex>
      {renderReviewDialog()}
    </Flex>
  );
});

export default Navbar;
